const { getCookie } = window.BAO.Utils

/* eslint-disable compat/compat */
class PdpBackInStockFlow extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.showForm = false

    if (this.els?.showEmailTrigger) {
      this.listeners.add(
        this.els?.showEmailTrigger?.element,
        'click',
        this.onShowEmailTrigger.bind(this),
      )
    }

    this.listeners.add(
      document,
      'variantChange',
      this.handleVariantChange.bind(this),
    )

    this.listeners.add(this.els?.emailForm?.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  handleVariantChange (event) {
    const variant = event.detail.variant

    this.hideEmailForm()

    const hasRegisteredCookie = Boolean(
      getCookie(`isRegistered-${variant.data.id}`),
    )

    this.els?.registeredMessage?.element?.setAttribute(
      'aria-hidden',
      !hasRegisteredCookie,
    )

    this.externalEls?.acceptMarketing?.elements?.forEach(element => {
      element.setAttribute('aria-hidden', Boolean(hasRegisteredCookie))
    })

    const showForm =
      !variant.data.available && this.showForm && !hasRegisteredCookie

    this.els?.emailForm?.element?.setAttribute('aria-hidden', !showForm)
    this.externalEls?.acceptMarketing?.elements?.forEach(element => {
      element.setAttribute('aria-hidden', !showForm)
    })
    this.setAttribute('aria-expanded', showForm)
  }

  onShowEmailTrigger () {
    if (
      this.els?.showEmailTrigger?.element?.getAttribute(
        'data-back-in-stock-modal-external-el',
      )
    ) {
      return
    }

    this.showForm = true

    this.setAttribute('aria-expanded', 'true')
    this.els?.showEmailTrigger?.element?.setAttribute(
      'hidden-on-desktop',
      'true',
    )
    this.els?.emailForm?.element?.setAttribute('aria-hidden', 'false')
    this.externalEls?.acceptMarketing?.elements?.forEach(element => {
      element.setAttribute('aria-hidden', 'false')
    })

    this.preventInputZoom()
  }

  preventInputZoom () {
    const iOS =
      navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

    if (iOS) {
      const viewport = document.querySelector('meta[name=viewport]')
      const initialContent = viewport.getAttribute('content')
      const newContent = `${initialContent}, maximum-scale=1.0`
      viewport.setAttribute('content', newContent)
    }
  }

  hideEmailForm () {
    this.showForm = false

    this.setAttribute('aria-expanded', 'false')
    this.els?.showEmailTrigger?.element?.setAttribute(
      'hidden-on-desktop',
      'false',
    )
    this.els?.emailForm?.element?.setAttribute('aria-hidden', 'true')
    this.externalEls?.acceptMarketing?.elements?.forEach(element => {
      element.setAttribute('aria-hidden', 'true')
    })
  }

  hideNotify () {
    this.setAttribute('aria-expanded', 'false')
    this.els?.emailForm?.element?.setAttribute('aria-hidden', 'true')
    this.externalEls?.acceptMarketing?.elements?.forEach(element => {
      element.setAttribute('aria-hidden', 'true')
    })
    this.els?.showEmailTrigger?.element?.setAttribute('aria-hidden', 'true')
  }

  showRegisteredState () {
    this.els?.registeredMessage?.element?.setAttribute('aria-hidden', 'false')
  }

  showError () {
    this.els?.error?.element?.setAttribute('aria-hidden', 'false')
  }

  hideError () {
    this.els?.error?.element?.setAttribute('aria-hidden', 'true')
  }

  BISSubmission (variantId, productId, emailAddress, acceptMarketing) {
    window.BIS.create(emailAddress, variantId, productId, {
      accepts_marketing: acceptMarketing,
    }).then(resp => {
      if (resp.status === 'OK') {
        this.hideNotify()
        this.showRegisteredState()
        this.hideError()
      } else if (
        resp.status === 'Error' &&
        resp.errors.base[0] ===
          'You have already registered for a notification for that item.'
      ) {
        this.showError()
      }
    })
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const request = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      {
        method: 'POST',
        headers: {
          revision: '2023-12-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    )

    if (!request.ok) {
      console.error(request)
    } else {
      this.hideNotify()
      this.showRegisteredState()
    }
  }

  onFormSubmission () {
    let variantId

    variantId = this.els?.emailForm?.element?.dataset?.variantId

    if (new URL(window.location).searchParams.has('variant')) {
      variantId = Number(new URL(window.location).searchParams.get('variant'))
    }

    const productId = Number(this.els?.emailForm?.element?.dataset?.productId)
    const emailAddress = this.els?.emailInput?.element?.value
    let acceptMarketing = false

    this.externalEls?.acceptMarketingCheckbox?.elements?.forEach(element => {
      if (element.checked) {
        acceptMarketing = true
      }
    })

    if (!emailAddress) {
      return
    }

    if (this.dataset.backEndFlow === 'klaviyo') {
      this.KlaviyoSubmission(variantId, emailAddress)

      if (acceptMarketing) {
        this.newsletterSubscribe(emailAddress)
      }
    } else {
      this.BISSubmission(variantId, productId, emailAddress, acceptMarketing)
    }
    window.BAO.Utils.setCookie(`isRegistered-${variantId}`, variantId, 14)
    window.BAO.Utils.setCookie(`isRegistered`, true, 31)
  }

  async newsletterSubscribe (emailAddress) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: window.theme.klaviyo.mailingListId,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2023-12-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.hideNotify()
        this.showRegisteredState()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }
}

if (!customElements.get('pdp-back-in-stock-flow')) {
  customElements.define('pdp-back-in-stock-flow', PdpBackInStockFlow)
}
